export default {
      id: "close-usage",
      viewBox: "0 0 25 25",
      url: "/" + "sprite.svg#close",
      toString: function () {
        return this.url;
      }
    }